import { Order } from "../../Utilities/SortableTableHead";
import { ActiveStatus } from "../Scorecard Management Filters/Utilities/ActiveStatus";
import ScorecardManagementTableRowViewModel from "./ScorecardManagementTableRowViewModel";

export default class ScorecardFiltersViewModel {
    public name: string = '';
    public client: string = '';
    public channel: string = '';
    public type: string = '';
    public activeStatus: ActiveStatus = '';
    public rowsPerPage: number = 10;
    public page: number = 0;
    public order: Order = 'asc';
    public orderBy: keyof ScorecardManagementTableRowViewModel = 'name';
}